/** Minimum scroll delta (px) before the bar toggles — filters out scroll jitter. */
export const SCROLL_DELTA_THRESHOLD = 8;

/** Within this many px of the top, the bar is always shown. */
export const TOP_THRESHOLD = 12;
